<div class="app-menubar-wrapper">
  <p-menubar [model]="leftItems" styleClass="app-menubar">
    <ng-template pTemplate="start">
      <img
        src="assets/img/nube_cc_200x140.png"
        alt="Catalog Cloud"
        height="22"
        class="mr-2"
      />
    </ng-template>
    <ng-template pTemplate="end">
      <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body" styleClass="user-menu-flat"></p-menu>
      <div class="menubar-user-info">
        <ng-container *ngIf="currentInstance">
          <span class="menubar-user-info__item">
            <i class="pi pi-server"></i>
            <span class="menubar-user-info__text">{{ currentInstance }}</span>
          </span>
          <span class="menubar-user-info__sep"></span>
        </ng-container>
        <ng-container *ngIf="currentOrg">
          <span class="menubar-user-info__item">
            <i class="pi pi-building"></i>
            <span class="menubar-user-info__text">{{ currentOrg }}</span>
          </span>
          <span class="menubar-user-info__sep"></span>
        </ng-container>
        <span class="menubar-user-info__item menubar-user-info__item--user menubar-user-info__item--clickable"
              (click)="userMenu.toggle($event)">
          <i class="pi pi-user"></i>
          <span class="menubar-user-info__text">{{ userName }}</span>
          <i class="pi pi-chevron-down menubar-user-info__chevron"></i>
        </span>
      </div>
    </ng-template>
  </p-menubar>
</div>
